var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "tt-host" }, [
    _c("div", { staticClass: "m-wrap" }, [
      _c("div", { staticClass: "m-hero" }, [
        _c("img", { staticClass: "m-bg", attrs: { src: _vm.bgSrc, alt: "" } }),
        _c("div", { staticClass: "m-title" }, [
          _c("div", { staticClass: "m-title__line1" }, [
            _vm._v(_vm._s(_vm.$t("Tabletop Game Guide"))),
          ]),
          _c("div", { staticClass: "m-title__line2" }, [
            _vm._v(_vm._s(_vm.$t("RULE: DON'T FALL OFF!"))),
          ]),
        ]),
        _c("div", { staticClass: "m-cards" }, [
          _c("div", { staticClass: "m-card m-card--left" }, [
            _c("img", {
              staticClass: "m-hex",
              attrs: { src: _vm.cardFightSrc, alt: "" },
            }),
            _c("div", { staticClass: "m-desc" }, [
              _vm._v(_vm._s(_vm.$t("Roosters fight on the table top arena."))),
            ]),
          ]),
          _c("div", { staticClass: "m-card m-card--right" }, [
            _c("div", { staticClass: "m-desc" }, [
              _vm._v(_vm._s(_vm.$t("First rooster to touch the floor LOSES."))),
            ]),
            _c("img", {
              staticClass: "m-hex",
              attrs: { src: _vm.cardLoseSrc, alt: "" },
            }),
          ]),
          _c("div", { staticClass: "m-card m-card--left" }, [
            _c("img", {
              staticClass: "m-hex",
              attrs: { src: _vm.cardWinSrc, alt: "" },
            }),
            _c("div", { staticClass: "m-desc" }, [
              _vm._v(_vm._s(_vm.$t("Rooster remaining on the table WINS."))),
            ]),
          ]),
          _c("div", { staticClass: "m-card m-card--right" }, [
            _c("div", { staticClass: "m-desc" }, [
              _vm._v(
                _vm._s(
                  _vm.$t("Draw when both rooster fall off at the same time")
                )
              ),
            ]),
            _c("img", {
              staticClass: "m-hex",
              attrs: { src: _vm.cardDrawSrc, alt: "" },
            }),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }